import * as d3 from 'd3';
//import moment from 'moment/src/moment';
import * as moment from 'moment';


import { SvgManager } from '../SvgManager';
import { ISeries } from '../pieces/series/index';

export class HorizonChart {
    private _svgManager: SvgManager;
    private _group: d3.Selection<any>;
    private _chart;
    private _bandHeight = 25;
    private _bandMargin = 5;
    private _series: ISeries[];
    private _width: number;
    private _data: any[];

    constructor(svgManager: SvgManager) {
        this._svgManager = svgManager;
        this._series = [];
        const svg = this._svgManager.container();
        this._group = svg.append('g')
            .classed('horizon', true);

        this._chart = (d3 as any).horizon()
            .height(this._bandHeight)
            .mode('offset')
            .interpolate('basis')
            .bands(3);

        this._svgManager.addResizeFunction((w, h) => {
            svg.attr({
                'width': w,
                height: h
            });
            this._chart.width(w);
            this._width = w;
        });
    }

    updateSeries(series: any[]) {
        this._series = series;
        const dataBound = this._group
            .selectAll('.horizon-band')
            .data(series);
        dataBound.exit().remove();
        const enterSelection = dataBound.enter();
        const groups = enterSelection.append('g')
            .classed('horizon-band', true);
        groups.append('rect')
            .classed('band-container', true)
            .attr({
                'width': this._width,
                'height': this._bandHeight
            });
        groups.append('g')
            .classed('horizon-chart', true);
        dataBound.attr('transform', (d, i) => `translate(0,${i * (this._bandHeight + this._bandMargin)})`);
    }

    updateData(data: any[]) {
        this._data = data;
        const mappedData = this._series.map(s => {
            return this._data
                .filter(d => s.identifier() === s.selector()(d))
                .map(d => {
                    return [moment(d.timeStamp).toDate(), d.Average];
                });
        });
    }
}